module.exports = __webpack_public_path__ + "img/icon1.1f163667.gif";